export enum dayMap {
  sun = 'sunday',
  mon = 'monday',
  tue = 'tuesday',
  wed = 'wednesday',
  thu = 'thursday',
  fri = 'friday',
  sat = 'saturday'
}
